/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Fragment } from 'react';
import { useStyles } from '~src/hooks/useStyles';
import { DbQuestionChangeLogItem } from '~src/types/db';
import { Avatar, Card, Comment, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { formatDate } from '~src/utils/formatDate';
import { styleFn } from '../style';

export type QuestionItemProps = {
  question: DbQuestionChangeLogItem;
};

const QuestionsChangeLogItem: React.FC<QuestionItemProps> = ({ question }) => {
  const styles = useStyles(styleFn);

  return (
    <div css={styles.container}>
      <Card bodyStyle={{ padding: '10px 15px' }} css={styles.cardContainer}>
        <Comment
          author={
            <Fragment>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Fragment>
                  <Avatar size="large" icon={<UserOutlined rev="user" />} />
                  <Typography style={{ paddingLeft: '15px', fontSize: '16px' }}>
                    {question.created_by?.full_name}
                  </Typography>
                </Fragment>
              </div>
            </Fragment>
          }
          content={question.question}>
          <div css={styles.actionsContainer}>
            <span css={styles.dateText}>
              {formatDate(question.created_at, 'long')}
            </span>
          </div>
        </Comment>
      </Card>
    </div>
  );
};

export default QuestionsChangeLogItem;
